import { Typography } from 'antd';
import { Comment } from '../../models/comment';
import styles from './Comment.module.scss';
import { LikeOutlined, LikeFilled, EyeInvisibleOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { deslikeComment, likeComment } from '../../service/comment';
import { useQuery } from 'react-query';
import { getUser } from '../../service/user';
import UserImage from '../UserImage/UserImage';
import { useUserStore } from '../../store/useUser';
import { useNavigate } from 'react-router-dom';

const { Paragraph } = Typography;

interface PropsComment {
  comment: Comment;
}

type Props = Pick< PropsComment, 'comment'>;

const SpoilerComment = () => {
  return(
    <div className={styles.spoilerComment}>
      <div><EyeInvisibleOutlined className={styles.icon} /></div>
      <div>Este comentário possui spoiler</div>
    </div>
  );
}

export const CommentBook = ({ comment }: Props) => {
  const navigate = useNavigate();
  const [like, setLike] = useState(Number(comment.isLiked));
  const [totalLikesComment, setTotalLikesComment] = useState(Number(comment.totalLikes));
  const [hideSpoiler, setHideSpoiler] = useState(Number(comment.isSpoiler));
  const date = new Date(comment.createdAt);
  const days = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];

  const currentUserId = useUserStore(state => state.id);
  
  const {data:user} = useQuery(
    ['user'],
    () => getUser(comment.userId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const likeDeslike = async () => {
    setLike(like === 1 ? 0 : 1);
    if(like === 0){
      await likeComment(comment.id, comment.bookId, currentUserId);
      setTotalLikesComment(totalLikesComment+1);
    } 
    if(like === 1) {
      await deslikeComment(comment.id, comment.bookId, currentUserId);
      setTotalLikesComment(totalLikesComment-1);
    }
  }

  return(
    <div className={styles.container} key={"comment_"+comment.id}>
      <div className={styles.headerComment}>
        <div className={styles.userContainer} onClick={() => navigate(`/user/${comment.userId}`)}>
          <UserImage style={styles.circleUser} path={user?.pathPhoto} name={user?.fullname}/>
          <span>{comment.username}</span>
        </div>
        <div className={styles.dateComment}>
          {""+days[date.getDay()]+", "+date.getDate()+"/"+(date.getMonth()+1)+"/"+date.getFullYear()}
        </div>
      </div>
      <div className={styles.bodyComment}>
        {hideSpoiler === 0 ? 
          (
            <Paragraph ellipsis={{ rows: 2, expandable: true, symbol: 'mais',  }}>{comment.content}</Paragraph>)
            : (<div title="Clique para visualizar" onClick={(event) => setHideSpoiler(0)}><SpoilerComment /></div>
          )
        }
      </div>
      <div className={styles.footComment}>
        <div className={styles.countLikes}>
          {totalLikesComment} leitores curtiram
        </div>
        <div className={styles.likeComment}
          onClick={likeDeslike}>
          {like === 0 ? <LikeOutlined className={styles.icon} /> : <LikeFilled className={styles.icon} />}
        </div>
      </div>
    </div>
  );
}